import { PageShell } from '../components/ui/DataPrimitives';
import React from 'react';
import { Link, Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import CustomerSalesDossier from '../components/CustomerSalesDossier';
import SalesAccountDirectory from '../components/SalesAccountDirectory';
import { useSalesData } from '../components/SalesDossierShared';
import CustomerTeamNotes from '../components/CustomerTeamNotes';
import './Customers.linear.css';

function LegacyAccountResolver({ token, accountId }) {
  const request = useSalesData('/api/sales-team-accounts', token);
  if (request.error) return <p role="alert">Customer could not be loaded. <button onClick={request.reload}>Retry</button></p>;
  if (!request.data) return <p role="status">Loading customer…</p>;
  const account = request.data.items.find(a => String(a.id) === String(accountId));
  if (account?.customer_codes.length === 1) return <AccountCustomerRedirect code={account.customer_codes[0]} />;
  return <Navigate replace to="/customers" />;
}
function AccountCustomerRedirect({ code }) {
  const [params] = useSearchParams();
  const next = new URLSearchParams(params);
  next.delete('account'); next.delete('team'); next.set('customer', code);
  return <Navigate replace to={`/customers?${next}#notes`} />;
}
export default function Customers() {
  const { token } = useAuth();
  const [params] = useSearchParams();
  const customer = params.get('customer'), account = params.get('account'), team = params.get('team');
  return <PageShell className="custd"><div className="custd-topbar"><Link to="/customers">Customers</Link>{(customer || account || team) && <span> / Dossier</span>}</div><main className="custd-wrap">
    {customer ? <CustomerSalesDossier customerCode={customer} token={token} renderNotes={props => <CustomerTeamNotes {...props} />} />
      : account || team ? <LegacyAccountResolver key={`${token}:${account || team}`} token={token} accountId={account || team} />
      : <><header className="custd-head"><div><h1 className="custd-name">Customers</h1></div></header><SalesAccountDirectory token={token} /></>}
  </main></PageShell>;
}
export function LegacyAccountRedirect() {
  const { id } = useParams();
  const location = useLocation();
  const next = new URLSearchParams(location.search);
  if (id) { next.delete('customer'); next.set('account', id); }
  return <Navigate replace to={`/customers?${next}${id ? '#notes' : location.hash}`} />;
}
